import { createContext, useContext } from "react";
import { TutorialContextValue } from "../../types/tutorial";

export const TutorialContext = createContext<TutorialContextValue | null>(null);

export const useTutorial = (): TutorialContextValue => {
  const ctx = useContext(TutorialContext);
  if (!ctx) {
    throw new Error("useTutorial must be used within a TutorialProvider");
  }
  return ctx;
};

export const useTutorialOptional = (): TutorialContextValue | null => {
  return useContext(TutorialContext);
};
